/**
 * Ensures a URL has a protocol prefix so it isn't treated as a relative path.
 * Returns empty string for falsy/blank inputs.
 */
export const formatExternalUrl = (url) => {
    if (!url || typeof url !== 'string') return '';
    const trimmed = url.trim();
    if (!trimmed) return '';
    return trimmed.startsWith('http') ? trimmed : `https://${trimmed}`;
};
